/**
 * @module hooks/useSettings
 * @category Hooks
 * @description Um hook que fornece acesso ao contexto de configurações da aplicação.
 * @returns {Object} O contexto de configurações.
 */
import { useContext } from 'react';
import SettingsContext from '../contexts/SettingsContext';

const useSettings = () => useContext(SettingsContext);

export default useSettings;
